import { GlobalController } from 'src/shared/global/GlobalController'
import ImportFile from './ImportFile'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: 'samae-import-file',
    name: 'samae.import.file',
    component: ImportFile,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
